import { PlanDetailsType } from 'src/types/types';

type ActivePackBalancesProps = {
  planDetails: PlanDetailsType | null;
};

export const ActivePackBalances = ({ planDetails }: ActivePackBalancesProps) => {
  if (!planDetails?.ticket_packs || planDetails.ticket_packs.length === 0) {
    return null;
  }

  const totalTickets = planDetails.pack_ticket_balance || 0;
  const totalEmails = planDetails.pack_email_balance || 0;
  const activePacks = planDetails.ticket_packs.filter((p) => p.status === 'active');

  // Find highest max ticket price across all active packs
  const maxTicketPrice =
    activePacks.length > 0 ? Math.max(...activePacks.map((p) => p.max_ticket_price || 0)) : 0;

  // Find next expiring pack
  const nextExpiry =
    activePacks.length > 0
      ? new Date(Math.min(...activePacks.map((p) => new Date(p.expires_at).getTime())))
      : null;

  return (
    <div className="mb-5">
      <h3 className="text-xl font-bold mb-3">Your Active Packs</h3>

      {/* Prominent Key Information - Matching pricing.tsx style */}
      <div className="grid mb-3">
        <div className="col-12 md:col-6">
          <div className="p-3 bg-green-50 border-round border-2 border-green-200">
            <div className="flex align-items-center justify-content-between">
              <div className="flex align-items-center">
                <i className="pi pi-ticket mr-2 text-green-600" style={{ fontSize: '1.1rem' }}></i>
                <span className="font-semibold text-700">Remaining Tickets:</span>
              </div>
              <span className="font-bold text-2xl text-900">{totalTickets.toLocaleString()}</span>
            </div>
          </div>
        </div>

        <div className="col-12 md:col-6">
          <div className="p-3 bg-blue-50 border-round border-2 border-blue-200">
            <div className="flex align-items-center justify-content-between">
              <div className="flex align-items-center">
                <i className="pi pi-tag mr-2 text-blue-600" style={{ fontSize: '1.1rem' }}></i>
                <span className="font-semibold text-700">Max Ticket Price:</span>
              </div>
              <span className="font-bold text-2xl text-900">
                ${maxTicketPrice.toLocaleString()}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Summary Stats */}
      <div className="grid">
        <div className="col-12 md:col-4">
          <div className="p-3 border-round" style={{ backgroundColor: '#f9fafb' }}>
            <div className="flex align-items-center gap-2 mb-2">
              <i className="pi pi-envelope text-xl" style={{ color: '#6b7280' }} />
              <span className="font-semibold text-sm">Remaining Emails</span>
            </div>
            <div className="text-2xl font-bold" style={{ color: '#374151' }}>
              {totalEmails.toLocaleString()}
            </div>
          </div>
        </div>

        <div className="col-12 md:col-4">
          <div className="p-3 border-round" style={{ backgroundColor: '#f9fafb' }}>
            <div className="flex align-items-center gap-2 mb-2">
              <i className="pi pi-box text-xl" style={{ color: '#6b7280' }} />
              <span className="font-semibold text-sm">Active Packs</span>
            </div>
            <div className="text-2xl font-bold" style={{ color: '#374151' }}>
              {activePacks.length}
            </div>
          </div>
        </div>

        {nextExpiry && (
          <div className="col-12 md:col-4">
            <div className="p-3 border-round" style={{ backgroundColor: '#fef2f2' }}>
              <div className="flex align-items-center gap-2 mb-2">
                <i className="pi pi-clock text-xl" style={{ color: '#dc2626' }} />
                <span className="font-semibold text-sm">Next Expiry</span>
              </div>
              <div className="text-lg font-bold" style={{ color: '#dc2626' }}>
                {nextExpiry.toLocaleDateString()}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
